import { createFileRoute } from "@tanstack/react-router";
import { PageHeader } from "@/client/components/page-header";
import { pageHead } from "@/client/lib/page";
import { SenhaForm } from "@/client/modules/senha/senha-form";

export const Route = createFileRoute("/app/senha")({
  head: () => pageHead("Minha senha"),
  component: () => (
    <div className="mx-auto flex max-w-7xl flex-col gap-6">
      <PageHeader title="Minha senha" description="Troque a senha de acesso ao sistema." />
      <SenhaForm />
    </div>
  ),
});
